var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0 6.988-5.12 12.78-11.813 13.83v-9.783h3.263L20.07 14h-3.883v-2.626c0-1.108.543-2.187 2.282-2.187h1.765V5.742S18.632 5.47 17.1 5.47c-3.197 0-5.288 1.938-5.288 5.447V14H8.258v4.047h3.555v9.783C5.12 26.78 0 20.988 0 14 0 6.268 6.268 0 14 0s14 6.268 14 14z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.45 18.047 20.07 14h-3.883v-2.626c0-1.107.543-2.187 2.282-2.187h1.765V5.742s-1.602-.273-3.133-.273c-3.198 0-5.288 1.938-5.288 5.447V14H8.258v4.047h3.555v9.783a14.105 14.105 0 0 0 4.374 0v-9.783h3.263z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bcf438b106b1cd33e37a0cd692b0bdad.svg";
export { ForwardRef as ReactComponent };